<template>
  <div class="bg-more">
    <!-- 出售你的葡萄酒 -->
    <section class="contact bg-light py-5">
      <div class="container-Contact">
        <h2 class="text-center font-weight-bold mb-3">{{ $t("sellwines.sellwinesFromFormat.titleFormat") }}</h2>
        <p class="text-center">
          {{ $t("sellwines.sellwinesFromFormat.contentFormat") }}
        </p>
        <validation-observer v-slot="{ invalid }">
          <form class="contactForm">
            <!-- Name -->
            <div class="form-group contactFormGroup">
              <validation-provider rules="required" v-slot="{ errors, classes, passed }">
                <label for="name" class="mb-2"><span class="text-danger">*</span> {{ $t("sellwines.formFormat.nameFormat") }}</label>
                <input
                  type="name"
                  class="form-control rounded-0"
                  id="name"
                  name="姓名"
                  v-model.trim="form.name"
                  :class="classes"
                  :placeholder="$t('sellwines.formFormat.namePlaceholder')"
                />
                <span v-if="errors[0]" class="invalid-feedback">{{ $t("sellwines.formFormat.namePlaceholder") }}</span>
                <span v-if="passed" class="valid-feedback">{{ $t("sellwines.formFormat.namePassed") }} </span>
              </validation-provider>
            </div>
            <!-- phone -->
            <div class="form-group contactFormGroup">
              <validation-provider rules="required|min:8" v-slot="{ errors, classes, passed }">
                <label for="phone" class="mb-2"> <span class="text-danger">*</span> {{ $t("sellwines.formFormat.phoneFormat") }}</label>
                <input
                  type="phone"
                  class="form-control rounded-0"
                  id="phone"
                  name="電話"
                  v-model.trim="form.phone"
                  :class="classes"
                  :placeholder="$t('sellwines.formFormat.phonePlaceholder')"
                />
                <span v-if="errors[0]" class="invalid-feedback">{{ $t("sellwines.formFormat.phonePlaceholder") }}</span>
                <span v-if="passed" class="valid-feedback">{{ $t("sellwines.formFormat.phonePassed") }}</span>
              </validation-provider>
            </div>
            <!-- Mail -->
            <div class="form-group contactFormGroup">
              <validation-provider rules="required|email" v-slot="{ errors, classes, passed }">
                <label for="email" class="mb-2"> <span class="text-danger">*</span> {{ $t("sellwines.formFormat.emailFormat") }}</label>
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  name="Email"
                  v-model.trim="form.email"
                  :class="classes"
                  :placeholder="$t('sellwines.formFormat.emailPlaceholder')"
                />
                <span v-if="errors[0]" class="invalid-feedback">{{ $t("sellwines.formFormat.emailPlaceholder") }}</span>
                <span v-if="passed" class="valid-feedback">{{ $t("sellwines.formFormat.emailPassed") }}</span>
              </validation-provider>
            </div>
            <!-- content -->
            <div class="form-group contactFormGroup">
              <validation-provider rules="required" v-slot="{ errors, classes, passed }">
                <label for="content" class="mb-2"><span class="text-danger">*</span> {{ $t("sellwines.formFormat.contentFormat") }} </label>
                <textarea
                  class="form-control"
                  id="content"
                  name="关于您的葡萄酒"
                  rows="10"
                  v-model.trim="form.content"
                  :class="classes"
                  :placeholder="$t('sellwines.formFormat.contentPlaceholder')"
                >
                </textarea>
                <span v-if="errors[0]" class="invalid-feedback">{{ $t("sellwines.formFormat.contentPlaceholder") }}</span>
                <span v-if="passed" class="valid-feedback">{{ $t("sellwines.formFormat.contentPassed") }}</span>
              </validation-provider>
            </div>
            <!-- Checkbox -->
            <div class="form-check contactFormGroup ">
              <validation-provider :rules="{ required: { allowFalse: false } }" v-slot="{ errors, classes, passed }">
                <input
                  type="checkbox"
                  id="privacy"
                  name="隱私權政策"
                  class="mb-2 form-check-input privacy"
                  v-model.trim="form.privacy"
                  :class="classes"
                />
                <label for="privacy">
                  {{ $t("sellwines.formFormat.privacyMsg") }}
                </label>
                <span v-if="errors[0]" class="invalid-feedback">{{ $t("sellwines.formFormat.privacyMsgPlaceholder") }}</span>
                <span v-if="passed" class="valid-feedback"> {{ $t("sellwines.formFormat.privacyPassed") }} </span>
              </validation-provider>
            </div>
            <!-- Submit -->
            <div>{{ $t("sellwines.formFormat.uploadMsg") }}</div>

            <div class="form-group row d-flex justify-content-center mt-5">
              <div class="col-md-4 mt-3 mt-md-0">
                <el-upload
                  :action="actionUrl"
                  :show-file-list="false"
                  accept=".pdf, .doc, .docx, .xls, .xlsx"
                  :limit="1"
                  :before-upload="beforeUpload"
                  :on-success="upSuccess"
                  :on-error="upError"
                >
                  <el-button
                    size="small"
                    :disabled="!!form.file_path"
                    class="btn btn-secondary btn-block d-flex align-items-center justify-content-center"
                  >
                    {{ $t("sellwines.submitFormat.uploadBtnFormat") }}
                  </el-button>
                </el-upload>
              </div>
              <div class="col-md-4 mt-3 mt-md-0">
                <button
                  type="button"
                  :disabled="invalid"
                  @click="contactSubmit"
                  class="btn btn-secondary btn-block d-flex align-items-center
                  justify-content-center"
                >
                  {{ $t("sellwines.submitFormat.btnFormat") }}
                </button>
              </div>
            </div>
          </form>
        </validation-observer>
      </div>
      <!-- contact Modal -->
      <div id="contactModal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header bg-secondary">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body bg-light text-center">
              <div class="h5 text-info font-weight-bold">感謝您的聯繫</div>
              <div class="h5 text-info font-weight-bold">我們將盡快與您聯絡！</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: "",
        phone: "",
        email: "",
        content: "",
        type: 3,
        file_path: "",
        privacy: false,
      },
      actionUrl: `${process.env.VUE_APP_APIPATH}/shop/v2/stock/upload/file`,
      fileList: [],
    };
  },
  methods: {
    contactSubmit() {
      const url = `${process.env.VUE_APP_APIPATH}//shop/v1/lifa/sub`;
      $("#contactModal").modal("show");
      this.$http
        .post(url, { ...this.form })
        .then((res) => {
          $("#contactModal").modal("hide");
        })
        .catch((error) => {
          $("#contactModal").modal("hide");
        });
    },
    // 上传文件之前
    beforeUpload(file) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);

      const whiteList = ["pdf", "doc", "docx", "xls", "xlsx"];

      if (whiteList.indexOf(fileSuffix) === -1) {
        this.$message({ message: "上传文件只能是 pdf、doc、docx、xls、xlsx格式", type: "error" });
        return false;
      }

      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message({ message: "上传文件大小不能超过 2MB", type: "warning" });
        return false;
      }
    },
    // 上传成功
    upSuccess(e) {
      const file = e.data.url;
      this.form.file_path = file;
      this.$message({ message: "上传成功", type: "success" });
    },
    // 上传失败
    upError(e) {
      this.$message.error("上传失败");
    },
  },
};
</script>
<style scoped>
/deep/.el-upload {
  width: 100%;
}
@media (max-width: 768px) {
  .map-box {
    flex-direction: column;
  }
  .map-body {
    margin-right: 0 !important;
  }
  .container-Contact {
    width: 90%;
  }
}
</style>
